import {
  PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE,
  PERMISSION_APPOINTMENT_CREATE,
  PERMISSION_APPOINTMENT_PROPOSAL_CONVERT,
  PERMISSION_APPOINTMENT_READ,
  PERMISSION_INTAKE_PROPOSAL_CONVERT,
  PERMISSION_LINKS_WIDGET,
  PERMISSION_ORDERS_CREATE,
  PERMISSION_ORDERS_READ,
  PERMISSION_ORDER_QUOTATIONS_READ,
  PERMISSION_ORDER_QUOTATIONS_UPDATE,
  PERMISSION_PRICEMARKUP_READ,
  PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE,
  PERMISSION_WORKORDER_CREATE,
  PERMISSION_WORKORDER_QUOTATIONS_READ,
  PERMISSION_WORKORDER_QUOTATIONS_UPDATE,
  PERMISSION_WORKORDER_READ
} from './Permissions'

export const PERMISSION_ONLY_ORDER_READ = {
  [PERMISSION_WORKORDER_READ]: false,
  [PERMISSION_WORKORDER_QUOTATIONS_READ]: false,
  [PERMISSION_ORDERS_READ]: true,
  [PERMISSION_ORDER_QUOTATIONS_READ]: true,
  [PERMISSION_PRICEMARKUP_READ]: true
}

export const PERMISSION_ONLY_PORTAL = {
  [PERMISSION_WORKORDER_CREATE]: false,
  [PERMISSION_WORKORDER_QUOTATIONS_UPDATE]: false,
  [PERMISSION_ORDERS_CREATE]: true,
  [PERMISSION_ORDER_QUOTATIONS_UPDATE]: true
}

export const PERMISSION_OFFLINE_RMA_ONLY_PORTAL = {
  [PERMISSION_WORKORDER_CREATE]: false,
  [PERMISSION_ORDERS_CREATE]: true
}

export const PERMISSION_ONLY_PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE = {
  // only in portal, user should not be allowed to enter additional account info
  // while in module 0, he IS allowed to enter additional info
  [PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE]: true,
  [PERMISSION_WORKORDER_CREATE]: false,
  [PERMISSION_ORDERS_CREATE]: true
}

export const PERMISSION_ONLY_MODULE_ZERO = {
  [PERMISSION_WORKORDER_READ]: false,
  [PERMISSION_ORDERS_READ]: false,
  [PERMISSION_APPOINTMENT_CREATE]: false,
  [PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE]: false,
  [PERMISSION_LINKS_WIDGET]: true
}

export const PERMISSION_GARAGE_ADMIN = {
  [PERMISSION_WORKORDER_READ]: false,
  [PERMISSION_ORDERS_READ]: false
}

export const PERMISSION_INTAKE_CONVERT = {
  anyIn: [PERMISSION_INTAKE_PROPOSAL_CONVERT, PERMISSION_APPOINTMENT_PROPOSAL_CONVERT]
}

// PERMISSION_APPOINTMENT_READ_PORTAL is a temporary permissions, used to hide menu item.
// A env feature flag was required to show/hide this for production, but the GMS want to show this on prod anyway.
export const PERMISSION_APPOINTMENT_READ_PORTAL = {
  [PERMISSION_APPOINTMENT_READ]: true,
  [PERMISSION_ORDERS_READ]: true
}

// PERMISSION_APPOINTMENT_READ_OTHERS is a temporary permissions, used to hide menu item.
// A env feature flag was required to show/hide this for production, but the GMS want to show this on prod anyway.
export const PERMISSION_APPOINTMENT_READ_OTHERS = {
  [PERMISSION_APPOINTMENT_READ]: true,
  [PERMISSION_ORDERS_READ]: false
}
